import { useMemo } from "react";
import { resources } from "@constants/hardcoded-strings";
import { LayoutTypes } from "@enums/layout-types";
import { FormattedRpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { ContentPageBody } from "@containers/common/content-page-body/content-page-body";
import { ContentPageHeader } from "@containers/common/content-page-header/content-page-header";
import { RadioInputFormGroup } from "@containers/common/radio-input-form-group/radio-input-form-group";
import commonStyles from "../../verification-service-details-component.less";

type IntegrationTypeTabContainerProps = {
    isDisabled: boolean;
    rpServiceConfigurationState: FormattedRpServiceConfiguration;
    setRpServiceConfigurationState: (state: FormattedRpServiceConfiguration) => void;
};

export const IntegrationTypeTabContainer = (props: IntegrationTypeTabContainerProps) => {
    const { isDisabled, rpServiceConfigurationState, setRpServiceConfigurationState } = props;

    const handleIntegrationTypeChange = (newValue: string) => {
        setRpServiceConfigurationState({
            ...rpServiceConfigurationState,
            generalSettings: {
                ...rpServiceConfigurationState.generalSettings,
                enableGatewayUI: newValue === "enabled"
            }
        });
    };

    const selectedOption = useMemo(() => {
        return rpServiceConfigurationState.generalSettings.enableGatewayUI ? "enabled" : "disabled";
    }, [rpServiceConfigurationState.generalSettings.enableGatewayUI]);

    const options = useMemo(() => [{
        label: resources.pages.verificationServiceDetails.tabs.general.subTabs.integrationType.options.enable,
        value: "enabled"
    },
    {
        label: resources.pages.verificationServiceDetails.tabs.general.subTabs.integrationType.options.disable,
        value: "disabled"
    }], []);

    return (
        <div>
            <ContentPageHeader title={resources.pages.verificationServiceDetails.tabs.general.subTabs.integrationType.title} />
            <ContentPageBody isMaxWidth={true}>
                <span className={commonStyles.description}>{resources.pages.verificationServiceDetails.tabs.general.subTabs.integrationType.descriptionLine1}</span>
                <span className={commonStyles.description}>{resources.pages.verificationServiceDetails.tabs.general.subTabs.integrationType.descriptionLine2}</span>
                <RadioInputFormGroup
                    controlId={"verification-service-details-enable-gateway-ui-radio"}
                    disabled={isDisabled}
                    isRequired={true}
                    label={""}
                    options={options}
                    value={selectedOption}
                    layout={LayoutTypes.COLUMN}
                    radioButtonLayout={LayoutTypes.COLUMN}
                    onChange={handleIntegrationTypeChange}
                />
            </ContentPageBody>
        </div>
    );
};